{
    "email-verification": {
        "title": "Verify your email address",
        "success_header": "You're good to go!",
        "success_body": "Thanks for verifying your email.",
        "success_cta": "Open the app",
        "fail_header": "Looks like something's off.",
        "fail_body": "We could not verify your email or it's already verified.",
        "fail_cta": "Open the app"
    }
}